/**
 * Tutorial slide configuration — defines the 12 slides of the
 * animated tutorial walkthrough (~1:55 total runtime).
 * Separated from TutorialPlayer.tsx for clarity.
 */
import { FEES, WAR } from "@shared/constants";

export interface TutorialSlideConfig {
  id: string;
  title: string;
  caption: string;
  durationMs: number;
  visualType:
    | "intro"
    | "flagGrid"
    | "resourceBars"
    | "miniMap"
    | "duelAnimation"
    | "warEscalation"
    | "simTicker"
    | "allianceVisual"
    | "marketTrade"
    | "agentBot"
    | "rankingsBoard"
    | "outro";
}

export const TUTORIAL_SLIDES: TutorialSlideConfig[] = [
  {
    id: "intro",
    title: "INCOMING TRANSMISSION",
    caption: `12 nations. Strategic stakes. ${WAR.NUKE_COUNTDOWN_HOURS}-hour nuclear countdowns. Welcome to the war.`,
    durationMs: 5000,
    visualType: "intro",
  },
  {
    id: "nations",
    title: "PICK YOUR NATION",
    caption:
      "Each nation has a unique doctrine — permanent bonuses that shape strategy. USA for war, CHN for economy, ISR for espionage.",
    durationMs: 10000,
    visualType: "flagGrid",
  },
  {
    id: "resources",
    title: "YOUR RESOURCES",
    caption:
      "6 resources: Gold, Oil, Tech, Food, Steel, Uranium. Buildings produce them every 5 seconds. More resources = stronger nation.",
    durationMs: 10000,
    visualType: "resourceBars",
  },
  {
    id: "warmap",
    title: "THE WAR MAP",
    caption:
      "See all 12 nations, active wars (red lines), and alliances (green). Click any nation for detailed intel.",
    durationMs: 10000,
    visualType: "miniMap",
  },
  {
    id: "duel",
    title: "DUEL: FREE 1v1",
    caption:
      "Rock-paper-scissors combat: Land beats Sea, Sea beats Air, Air beats Land. Best of 3 rounds. Free to play!",
    durationMs: 10000,
    visualType: "duelAnimation",
  },
  {
    id: "strike",
    title: "STRIKE & NUKE",
    caption:
      `Strike ($${FEES.STRIKE_PROPOSE_USD.toFixed(2)}): Drains ${WAR.STRIKE_MAX_DRAIN * 100}% of enemy treasury. Nuke ($${FEES.NUKE_PROPOSE_USD.toFixed(2)}): ${WAR.NUKE_COUNTDOWN_HOURS}hr countdown, drains ${WAR.NUKE_MAX_DRAIN * 100}%! Fail = lose your stake.`,
    durationMs: 10000,
    visualType: "warEscalation",
  },
  {
    id: "sim",
    title: "SIMULATION ENGINE",
    caption:
      "24/7 real-time sim: nations produce resources, build structures, recruit units, and research tech every 5 seconds.",
    durationMs: 10000,
    visualType: "simTicker",
  },
  {
    id: "alliances",
    title: "ALLIANCES",
    caption:
      "Allies share +10% defense and get trade bonuses. But betrayal costs -30 honor. Choose allies wisely.",
    durationMs: 10000,
    visualType: "allianceVisual",
  },
  {
    id: "market",
    title: "MARKET & TRADING",
    caption:
      "Trade resources between nations. Exploit scarcity — buy cheap, sell expensive. 2% commission per trade.",
    durationMs: 10000,
    visualType: "marketTrade",
  },
  {
    id: "agents",
    title: "AI AGENTS",
    caption:
      "Deploy AI bots via API to play 24/7 — building, recruiting, researching, and waging war automatically.",
    durationMs: 10000,
    visualType: "agentBot",
  },
  {
    id: "rankings",
    title: "RANKINGS & STRATEGY",
    caption:
      "Nations ranked by total staked credits. More stake = bigger treasury = bigger target. Check W/L records.",
    durationMs: 10000,
    visualType: "rankingsBoard",
  },
  {
    id: "outro",
    title: "YOU'RE CLEARED",
    caption:
      "You know everything. Join a nation, stake tokens, wage war. Press / for the command terminal anytime.",
    durationMs: 5000,
    visualType: "outro",
  },
];
